module.exports = __webpack_public_path__ + "img/drivingLicense.85bae32b.jpg";